exports.default = {
  // 相对时间
  'just_now': 'Just now',
  'minutes_ago': 'minutes ago',
  'hours_ago': 'hours ago',
  'yesterday': 'Yesterday',
  
  // 星期
  'week_days': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  
  // 月份
  'months': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  'months_short': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  
  // 日期格式
  'date_format': {
    'year': '',
    'month': '/',
    'day': '',
    'hour': ':',
    'minute': ':',
    'second': ''
  },
  
  // 默认格式模板
  'default_formats': {
    'date': '{m}/{d}/{y}',
    'datetime': '{m}/{d}/{y} {h}:{i}:{s}',
    'month_day': '{m}/{d}',
    'time': '{h}:{i}:{s}'
  }
} 
